import {createApp} from 'vue';

import searchBarMixin from './searchBarMixin';

let searchBarElement = document.getElementById('SearchBar');

if (searchBarElement !== null) {

    let searchBaseUrl = searchBarElement.dataset.searchBaseUrl;
    let selectedDestination = searchBarElement.dataset.selectedDestination;
    let selectedType = searchBarElement.dataset.selectedType;

    createApp({
        data() {
            return {
                loading: false,
                apiError: false,
            }
        },
        props: [
            'searchBaseUrl',
            'selectedDestination',
            'selectedType'
        ],
        mixins: [searchBarMixin],
        watch: {
            async destination() {
                await this.doSearch();
            },
            async type() {
                await this.doSearch();
            },
        },
        methods: {
            async doSearch() {
                this.page = 0;
                this.results = [];
                await this.getResults();
            },
        },
        computed: {
            redirectLink() {
                const nextURL = new URL(this.searchBaseUrl);
                for (const [key, value] of Object.entries(this.searchData)) {
                    nextURL.searchParams.append(key, value);
                }
                return nextURL;
            }
        },
        async mounted() {
            if (this.selectedDestination !== undefined) {
                this.destination = this.selectedDestination;
            }

            if (this.selectedType !== undefined) {
                this.type = this.selectedType;
            }

            await this.getResults();
        },
    }, {
        searchBaseUrl: searchBaseUrl,
        selectedDestination: selectedDestination,
        selectedType: selectedType
    }).mount('#SearchBar');

}